export default "__VITE_ASSET__PdbWu1wJ__"